export default __webpack_public_path__ + "static/media/mail-icon.20d44b6b.svg";